import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import FlexColumn from '../../FlexColumn'
import FlexRow from '../../FlexRow'
import MarkupPreview from '../../../atoms/MarkupPreview'
import { useFormattingContext } from '../../../organisms/FormattingProvider/FormattingContext'

export default function NoteV1 ({ activity, length, onClick, className, style }) {
  const { formatter } = useFormattingContext()
  const _style = {
    backgroundColor: '#fbfcbd',
    border: '1px solid #ffe09c',
    ...(style || {})
  }

  return (
    <FlexColumn className={clsx(className, 'gap-sm clickable radius-md p-md shadow-sm')} style={_style} onClick={onClick}>
      <FlexRow className='justify-between'>
        <div>{activity.subject}</div>
        <div>{formatter(activity.createdDate, 'date')}</div>
      </FlexRow>
      <div style={{ textOverflow: 'ellipsis', overflow: 'auto' }}>
        <MarkupPreview type='html' length={length} value={activity.content} />
      </div>
    </FlexColumn>
  )
}

NoteV1.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    content: PropTypes.string,
    createdDate: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  length: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
}
